import { Typography } from '@remarkable/ark-web';
import clsx from 'clsx';
import type { ReactNode } from 'react';
import { useEffect } from 'react';
import { useDelayedState } from 'src/utils/useDelayedState';

export function SidebarLabel({
  expanded,
  children,
  transitionDelay = 100,
}: {
  expanded: boolean;
  children: ReactNode;
  transitionDelay?: number;
}) {
  const [isHidden, setIsHidden] = useDelayedState(!expanded);

  useEffect(() => {
    if (expanded) {
      setIsHidden(false);
    } else {
      setIsHidden(true, transitionDelay); // Delay hiding the element until after the collapse animation
    }
  }, [expanded, setIsHidden]);

  return (
    <Typography
      variant="interface-sm"
      as="span"
      className={clsx(
        'm-16 mb-8 h-16 w-full overflow-x-clip font-light whitespace-nowrap transition-all',
        {
          'opacity-0': !expanded,
          'opacity-100': expanded,
          hidden: isHidden,
        }
      )}
    >
      {children}
    </Typography>
  );
}
